import React from "react";

export function Card({ as: Comp = "div", className = "", hoverable = false, children, ...props }) {
  const base =
    "em-card" + (hoverable ? " em-card-hover cursor-pointer" : "");
  return (
    <Comp className={`${base} ${className}`} {...props}>
      {children}
    </Comp>
  );
}

export function CardHeader({ eyebrow, title, action, className = "" }) {
  return (
    <div className={`flex items-start justify-between mb-6 gap-4 ${className}`}>
      <div className="min-w-0">
        {eyebrow && (
          <p className="text-[10px] uppercase tracking-[0.24em] text-zinc-500 font-semibold mb-2">{eyebrow}</p>
        )}
        {title && <h3 className="font-display text-xl sm:text-2xl font-medium tracking-tight text-white">{title}</h3>}
      </div>
      {action && <div className="shrink-0">{action}</div>}
    </div>
  );
}

export default Card;
